import React, { useState, useRef } from 'react';
import { useDispatch } from "react-redux";
import { createaddmission } from '../../ReduxToolkit/Slice/Addmission/Addmission';
import 'react-loading-skeleton/dist/skeleton.css';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import PageTitle from '../../components/Title/PageTitle';

function Registration() {
    const dispatch = useDispatch();
    const closeButtonRef = useRef(null);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [dob, setDob] = useState('');
    const [stander, setStander] = useState('');
    const [password, setPassword] = useState('');
    // hide and show password
    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    // create
    const handleSubmit = async (e) => {
        e.preventDefault()
        const data = {
            name,
            email,
            phone,
            dob,
            stander,
            password
        };
        dispatch(createaddmission(data));
        setName('');
        setEmail('');
        setPhone('');
        setDob('');
        setStander('');
        setPassword("");
        closeButtonRef.current.click();

    };

    return (
        <>
            <Button
                data-bs-toggle="modal"
                data-bs-target="#exampleModalRegistration"
                children={"Addmissions"}
                icon="plus-circle-fill"
            />
            {/* model */}
            <div
                className="modal fade"
                id="exampleModalRegistration"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <PageTitle className={"modal-title fs-5"} children={"Addmission Form"}/>
                            <Button
                                type="button"
                                bgColor='white'
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <form action="" onSubmit={handleSubmit}>
                                <Input
                                    label="Name"
                                    type="text"
                                    placeholder="Name"
                                    value={name}
                                    required
                                    onChange={(e) => setName(e.target.value)}
                                />
                                <Input
                                    label="Email"
                                    type="email"
                                    placeholder="Email"
                                    value={email}
                                    required
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <Input
                                    label="Phone"
                                    type="phone"
                                    placeholder="Enter Your Number"
                                    value={phone}
                                    required
                                    onChange={(e) => setPhone(e.target.value)}
                                />
                                <Input
                                    label="Date of Birth"
                                    type="date"
                                    value={dob}
                                    required
                                    onChange={(e) => setDob(e.target.value)}
                                />
                                <Input
                                    label="Course"
                                    type="text"
                                    value={stander}
                                    required
                                    placeholder="Standard"
                                    onChange={(e) => setStander(e.target.value)}
                                />
                                <div className="d-grid my-3">
                                    <label htmlFor="">
                                        Set Password
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            required
                                            className="form-control"
                                            placeholder="********"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        <sapn
                                            className="border px-2 bg-light text-center pt-1"
                                            onClick={togglePasswordVisibility}
                                        >
                                            {showPassword ? "Hide" : "Show"}
                                        </sapn>
                                    </div>
                                </div>

                                <div className={`modal-footer`}>
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        data-bs-dismiss="modal"
                                        ref={closeButtonRef}
                                    >
                                        Close
                                    </button>
                                    <Button type="submit" children={"Upload"} />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Registration